module.exports = __webpack_public_path__ + "static/media/наряженный домик 4.2846457e.jpg";